import React, { ReactNode } from 'react';
import { IonText } from '@ionic/react';
import { Card } from '../../components/Card';
import { IconComponent } from '../../theme/Icons';
import { IThemeColor } from '../../theme/IThemeColor';
import { CheckinIcon } from '../components/CheckinIcon';

interface IStatCardProps {
    Icon: IconComponent;
    iconColor: IThemeColor;
    value: string;
    description: string;
    changeIndicator?: ReactNode;
    'data-id'?: string;
}

export const StatCard: React.FC<IStatCardProps> = ({ value, description, Icon, iconColor, changeIndicator, 'data-id': dataId }) => {
    return (
        <Card dataProps={{dataId}}>
            <div style={{margin: '16px 0', display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center'}}>

                <CheckinIcon
                    active
                    Icon={Icon}
                    iconSize="medium"
                    activeColor={iconColor}
                />

                <IonText data-type="stat-value"><span style={{fontSize: 22, fontWeight: 'bold'}}>{value}</span></IonText>
                <IonText data-type="stat-desc"><span style={{fontSize: 12, textAlign: 'center'}}>{description}</span></IonText>

                <div style={{marginTop: 20, height: 15}}>
                    {changeIndicator}
                </div>
            </div>
        </Card>
    );
};
